import { Button, Checkbox, Dialog } from '@/components/DesignSystem';
import { Stack } from '@mui/material';
import { useState } from 'react';

interface TransactionSyncConfirmModalProps {
  onCancel: () => void,
  onConfirm: () => void,
}

export const TransactionSyncConfirmModal = ({
  onCancel,
  onConfirm,
}: TransactionSyncConfirmModalProps) => {
  const [isRewardProgramComplete, setIsRewardProgramComplete] = useState(false);
  const [areLocationManagersSet, setAreLocationManagersSet] = useState(false);
  const [areSalespersonLocationsSet, setAreSalespersonLocationsSet] = useState(false);
  const [areLoyaltySkusSet, setAreLoyaltySkusSet] = useState(false);
  const [isExcludedAccountsComplete, setIsExcludedAccountsComplete] = useState(false);
  const [isExcludedProductsComplete, setIsExcludedProductsComplete] = useState(false);
  const [isLinkedAccountsComplete, setIsLinkedAccountsComplete] = useState(false);
  const [isTierOverrideComplete, setIsTierOverrideComplete] = useState(false);


  const isContinueEnabled = isRewardProgramComplete
    && areLocationManagersSet
    && areSalespersonLocationsSet
    && areLoyaltySkusSet
    && isExcludedAccountsComplete
    && isExcludedProductsComplete
    && isLinkedAccountsComplete
    && isTierOverrideComplete;

  return (
    <Dialog
      acceptButton={(props) => (
        <Button
          {...props}
          disabled={!isContinueEnabled}
          onClick={onConfirm}
        >
          Continue
        </Button>
      )}
      cancelButton={(props) => (
        <Button
          {...props}
          onClick={onCancel}
        >
          Go back
        </Button>
      )}
      onClose={onCancel}
      open
      subtitle={"Please confirm that you have completed each of the following " +
        "pre-requisites by selecting the checkbox."}
      testID="confirm-transaction-sync-modal"
      title="Transaction Sync"
    >
      <Stack gap="16px">
        <Checkbox
          checked={isRewardProgramComplete}
          onChangeChecked={(checked) => setIsRewardProgramComplete(checked)}
          testID="rewards-program-checkbox"
        >
          Rewards program is completely set-up
        </Checkbox>
        <Checkbox
          checked={areLocationManagersSet}
          onChangeChecked={(checked) => setAreLocationManagersSet(checked)}
          testID="location-managers-checkbox"
        >
          All locations have a location manager set
        </Checkbox>
        <Checkbox
          checked={areSalespersonLocationsSet}
          onChangeChecked={(checked) => setAreSalespersonLocationsSet(checked)}
          testID="salesperson-locations-checkbox"
        >
          All salespersons are added to the correct location
        </Checkbox>
        <Checkbox
          checked={areLoyaltySkusSet}
          onChangeChecked={(checked) => setAreLoyaltySkusSet(checked)}
          testID="loyalty-skus-checkbox"
        >
          Loyalty SKU’s have been added to the retailer and associated manufacturer records
        </Checkbox>
        <Checkbox
          checked={isExcludedAccountsComplete}
          onChangeChecked={(checked) => setIsExcludedAccountsComplete(checked)}
          testID="excluded-accounts-checkbox"
        >
          Customer ‘excluded accounts’ manual import is completed
        </Checkbox>
        <Checkbox
          checked={isExcludedProductsComplete}
          onChangeChecked={(checked) => setIsExcludedProductsComplete(checked)}
          testID="excluded-products-checkbox"
        >
          Customer ‘excluded products’ manual import is completed
        </Checkbox>
        <Checkbox
          checked={isLinkedAccountsComplete}
          onChangeChecked={(checked) => setIsLinkedAccountsComplete(checked)}
          testID="linked-accounts-checkbox"
        >
          Customer ‘linked accounts’ manual import is completed
        </Checkbox>
        <Checkbox
          checked={isTierOverrideComplete}
          onChangeChecked={(checked) => setIsTierOverrideComplete(checked)}
          testID="tier-override-checkbox"
        >
          Customer ‘tier overrides’ manual import is completed
        </Checkbox>
      </Stack>
    </Dialog>
  );
};
